// extracted by mini-css-extract-plugin
export default {"exitButton":"GameExitButton_exitButton__KSs-R","exitIcon":"GameExitButton_exitIcon__+MUyj"};